import React from "react";
import { Container, styled } from '@mui/material';

export const CenteredLayout: React.FC<{ children: React.ReactNode }> = (props) => {
    return (
        <>
            <Container maxWidth="sm" sx={{
                padding: "30px",
            }}>
                {props.children}
            </Container>
        </>
    );
}
